export default __webpack_public_path__ + "static/white-brush-63e3d69214dd41140173d48c4c4cb844.png";